import { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import useApi from "../../../hooks/api.hook";

export default function Uploaded() {

    const [game, setGame] = useState();
    const location = useLocation();
    const pathParams = useParams();
    const api = new useApi(true);

    useEffect(() => {
        api.get(`/image/current_user/game/${pathParams.id}`).then(response => {
            if (!response.error) {
                console.log(response.data);
                setGame( {...response.data, game_logs: response.data.game_logs.map(l=>({...l, data: JSON.parse(l.data)}))} );
            }
        })
    }, [pathParams]);

    return (<>

        <h3>Game Info</h3><hr/>

        <div className="d-md-flex gap-3 flex-wrap">

            {!game && <div>Loading...</div>}

            {game &&
                <>
                    <div>
                        <img src={`${process.env.REACT_APP_API_BASE_URL}/static/${game.image}`} />

                        <h6 className="my-3">Assigned Slots</h6>
                        {game.game_instances ? <div className="d-flex gap-1 mb-3">
                            {game.game_instances.map(gi =>
                                <button className="btn btn-xs btn-light" key={gi.id}>{gi.grid_location}</button>
                            )}
                        </div> : <span>Not assigned any slots yet</span>}
                    </div>

                    <div className="flex-fill" style={{maxHeight:"400px", overflow:"hidden", overflowY:"auto"}}>
                        <h3>Game event logs</h3>
                        { game.game_logs.length > 0 ? <div>
                            {game.game_logs.map(log=><div key={log.id}>
                                <span className="badge bg-secondary me-2">
                                    {(new Date(log.createdAt)).toLocaleString()}
                                </span>
                                <span>
                                { log.data.type ? `${log.event} when playing` : log.event }
                                </span>
                            </div>)}
                        </div> : <span>No event around this game</span> }
                    </div>
                </>
            }

        </div>
    </>);
}